import { render } from "./ProfileNotificacoesTab.vue?vue&type=template&id=5e14f80e&scoped=true&ts=true"
import script from "./ProfileNotificacoesTab.vue?vue&type=script&lang=ts"
export * from "./ProfileNotificacoesTab.vue?vue&type=script&lang=ts"

import "./ProfileNotificacoesTab.vue?vue&type=style&index=0&id=5e14f80e&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5e14f80e"]])

export default __exports__